export enum PAGE_TYPES {
  NEW_PURCHASE_REPORT = "NEW_PURCHASE_REPORT",
  PURCHASE_REPORT_DETAILS = "PURCHASE_REPORT_DETAILS",
  NEW_REPORTING_ENTITY = "NEW_REPORTING_ENTITY",
  REPORTING_ENTITY_DETAILS = "REPORTING_ENTITY_DETAILS",
  NEW_PURCHASE_REPORT_BOOK = "NEW_PURCHASE_REPORT_BOOK",
  PURCHASE_REPORT_BOOK_DETAILS = "PURCHASE_REPORT_BOOK_DETAILS"
}
